import { COOKIE_KEYS, removeCookie } from '@register-ui/utils';
import { useEffect } from 'react';
import { OnboardingLayout } from '../onboarding-layout';

export const CHROME_DOWNLOAD_URL = 'https://www.google.com/chrome';

export function ChromeOnly() {
    useEffect(() => {
        removeCookie(COOKIE_KEYS.DEVICE_INFO_VARIABLE);
    }, []);

    return (
        <OnboardingLayout actions={[]}>
            <div className='mx-auto mb-60 flex w-468 max-w-full flex-1 flex-col items-center justify-center text-center'>
                <img
                    className='mb-32 h-120 w-auto'
                    src='/illustrations/support-request-default.svg'
                    alt='Unsupported device'
                />

                <h2 className='mb-20 font-general-sans text-24 font-semibold text-content-heading-default'>
                    Please use Google Chrome to continue
                </h2>
                <p className='text-base font-normal text-content-subtext-default'>
                    Moniebook's Web Register requires Google Chrome for proper
                    functionality. To continue, please open this link in the
                    Chrome app or{' '}
                    <a
                        className='text-base font-normal underline'
                        target='_blank'
                        rel='noopener noreferrer'
                        href={CHROME_DOWNLOAD_URL}>
                        download Google Chrome.
                    </a>
                </p>
            </div>
        </OnboardingLayout>
    );
}
